import {Typography} from '@mui/material';
import {GridColDef} from '@mui/x-data-grid';
import {ReactComponent as InfoIcon} from '../../assets/images/info-icon.svg';

export const widgetIdMapping = {
  endToEnd: -8,
  reviewerProductivity: -5,
  tagging: -3,
  rateTrend: -19,
  reviewerProgress: -6,
  totalReviewProgress: -17,
};
export const domainAdminDashboardColumns: GridColDef[] = [
  {
    field: 'projectName',
    headerName: 'Project Name',
    headerClassName: 'typo-text label2_size',
    flex: 1,
    minWidth: 154,
    renderCell: (params) => {
      return (
        <Typography
          className="typo-text label3_size project-name-text"
          data-testid={`dashboard-utils-projectName-${params.id}`}
        >
          {params.row.projectName}
        </Typography>
      );
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    headerClassName: 'typo-text label2_size',
    flex: 1,
    minWidth: 118,
  },
  {
    field: 'utcDate',
    flex: 1,
    minWidth: 209,
    renderHeader: () => {
      return (
        <>
          <Typography
            className="typo-text label2_size"
            data-testid={`dashboard-utils-data-as-of-utc`}
          >
            Data as of (UTC)
          </Typography>
          <InfoIcon className="info-icon" />
        </>
      );
    },
    renderCell: (params) => {
      return (
        <div data-testid={`dashboard-utils-div-utc-date-time-${params.id}`}>
          <Typography
            className="typo-text body3_size utc-date-text"
            data-testid={`dashboard-utils-utc-date--${params.id}`}
          >
            {params.row.utcDate.date}
          </Typography>
          <Typography
            className="typo-text body4_size utc-time-text"
            data-testid={`dashboard-utils-utc-time-${params.id}`}
          >
            {params.row.utcDate.time}
          </Typography>
        </div>
      );
    },
  },
  {
    field: 'custodians',
    flex: 1,
    minWidth: 187,
    renderHeader: () => {
      return (
        <>
          <Typography
            className="typo-text label2_size"
            data-testid={`dashboard-utils-custodians`}
          >
            Custodians
          </Typography>
          <InfoIcon className="info-icon" />
        </>
      );
    },
  },
  {
    field: 'docsPublished',
    flex: 1,
    minWidth: 216,
    renderHeader: () => {
      return (
        <>
          <Typography
            className="typo-text label2_size"
            data-testid={`dashboard-utils-docs-published`}
          >
            Docs Published (#)
          </Typography>
          <InfoIcon className="info-icon" />
        </>
      );
    },
  },
  {
    field: 'docsReleased',
    flex: 1,
    minWidth: 214,
    renderHeader: () => {
      return (
        <>
          <Typography
            className="typo-text label2_size"
            data-testid={`dashboard-utils-docs-released`}
          >
            Docs Released (#)
          </Typography>
          <InfoIcon className="info-icon" />
        </>
      );
    },
  },
  {
    field: 'corporateClient',
    headerName: 'Corporate Client',
    headerClassName: 'typo-text label2_size',
    flex: 1,
    minWidth: 171,
  },
  {
    field: 'createdDate',
    headerName: 'Created Date',
    headerClassName: 'typo-text label2_size',
    flex: 1,
    minWidth: 217,
  },
];

export const domainAdminDashboardColumnsMapping = [
  {
    id: 'ProjectID',
    key: 'domainDashboard.gridColumns.projectID',
    tooltipKey: 'domainDashboard.columnTooltips.projectID',
  },
  {
    id: 'ProjectLabel',
    key: 'domainDashboard.gridColumns.projectLabel',
    tooltipKey: 'domainDashboard.columnTooltips.projectLabel',
  },
  {
    id: 'IsActive',
    key: 'domainDashboard.gridColumns.isActive',
    tooltipKey: 'domainDashboard.columnTooltips.isActive',
  },
  {
    id: 'LastUpdatedOn',
    key: 'domainDashboard.gridColumns.lastUpdatedOn',
    tooltipKey: 'domainDashboard.columnTooltips.lastUpdatedOn',
  },
  {
    id: 'Firm',
    key: 'domainDashboard.gridColumns.firm',
    tooltipKey: 'domainDashboard.columnTooltips.firm',
  },
  {
    id: 'NoOfSecurityGroup',
    key: 'domainDashboard.gridColumns.noOfSecurityGroup',
    tooltipKey: 'domainDashboard.columnTooltips.noOfSecurityGroup',
  },
  {
    id: 'NoOfIngestion',
    key: 'domainDashboard.gridColumns.noOfIngestion',
    tooltipKey: 'domainDashboard.columnTooltips.noOfIngestion',
  },
  {
    id: 'NoOfCustodian',
    key: 'domainDashboard.gridColumns.noOfCustodian',
    tooltipKey: 'domainDashboard.columnTooltips.noOfCustodian',
  },
  {
    id: 'NoOfPublishedDocument',
    key: 'domainDashboard.gridColumns.noOfPublishedDocument',
    tooltipKey: 'domainDashboard.columnTooltips.noOfPublishedDocument',
  },
  {
    id: 'NoOfReleasedDocument',
    key: 'domainDashboard.gridColumns.noOfReleasedDocument',
    tooltipKey: 'domainDashboard.columnTooltips.noOfReleasedDocument',
  },
  {
    id: 'NoOfReponsiveDocument',
    key: 'domainDashboard.gridColumns.noOfReponsiveDocument',
    tooltipKey: 'domainDashboard.columnTooltips.noOfReponsiveDocument',
  },
  {
    id: 'NoOfPrivilegedDocument',
    key: 'domainDashboard.gridColumns.noOfPrivilegedDocument',
    tooltipKey: 'domainDashboard.columnTooltips.noOfPrivilegedDocument',
  },
  {
    id: 'NoOf1LRAssignment',
    key: 'domainDashboard.gridColumns.noOf1LRAssignment',
    tooltipKey: 'domainDashboard.columnTooltips.noOf1LRAssignment',
  },
  {
    id: 'NoOf1LRCompletedDocument',
    key: 'domainDashboard.gridColumns.noOf1LRCompletedDocument',
    tooltipKey: 'domainDashboard.columnTooltips.noOf1LRCompletedDocument',
  },
  {
    id: 'NoOf2LRAssignment',
    key: 'domainDashboard.gridColumns.noOf2LRAssignment',
    tooltipKey: 'domainDashboard.columnTooltips.noOf2LRAssignment',
  },
  {
    id: 'NoOf2LRCompletedDocument',
    key: 'domainDashboard.gridColumns.noOf2LRCompletedDocument',
    tooltipKey: 'domainDashboard.columnTooltips.noOf2LRCompletedDocument',
  },
  {
    id: 'NoOfProducedDocument',
    key: 'domainDashboard.gridColumns.noOfProducedDocument',
    tooltipKey: 'domainDashboard.columnTooltips.noOfProducedDocument',
  },
  {
    id: 'ProjectLastLoginActivity',
    key: 'domainDashboard.gridColumns.projectLastLoginActivity',
    tooltipKey: 'domainDashboard.columnTooltips.projectLastLoginActivity',
  },
  {
    id: 'ProjectLastDocumentActivity',
    key: 'domainDashboard.gridColumns.projectLastDocumentActivity',
    tooltipKey: 'domainDashboard.columnTooltips.projectLastDocumentActivity',
  },
  {
    id: 'CorpClient',
    key: 'domainDashboard.gridColumns.corpClient',
    tooltipKey: 'domainDashboard.columnTooltips.corpClient',
  },
  {
    id: 'ProjectCreatedOn',
    key: 'domainDashboard.gridColumns.projectCreatedOn',
    tooltipKey: 'domainDashboard.columnTooltips.projectCreatedOn',
  },
  {
    id: 'ProjectCreatedBy',
    key: 'domainDashboard.gridColumns.projectCreatedBy',
    tooltipKey: 'domainDashboard.columnTooltips.projectCreatedBy',
  },
  {
    id: 'NoOfUser',
    key: 'domainDashboard.gridColumns.noOfUser',
    tooltipKey: 'domainDashboard.columnTooltips.noOfUser',
  },
  {
    id: 'BillableUserCount',
    key: 'domainDashboard.gridColumns.billableUserCount',
    tooltipKey: 'domainDashboard.columnTooltips.billableUserCount',
  },
  {
    id: 'TotalUtilizedDiskSize',
    key: 'domainDashboard.gridColumns.totalUtilizedDiskSize',
    tooltipKey: 'domainDashboard.columnTooltips.totalUtilizedDiskSize',
  },
  {
    id: 'TotalDBDiskSize',
    key: 'domainDashboard.gridColumns.totalDBDiskSize',
    tooltipKey: 'domainDashboard.columnTooltips.totalDBDiskSize',
  },
  {
    id: 'TotalIndexSize',
    key: 'domainDashboard.gridColumns.totalIndexSize',
    tooltipKey: 'domainDashboard.columnTooltips.totalIndexSize',
  },
  {
    id: 'TotalWorkspaceSize',
    key: 'domainDashboard.gridColumns.totalWorkspaceSize',
    tooltipKey: 'domainDashboard.columnTooltips.totalWorkspaceSize',
  },
  {
    id: 'ConsilioAnalyticsIndexSize',
    key: 'domainDashboard.gridColumns.consilioAnalyticsIndexSize',
    tooltipKey: 'domainDashboard.columnTooltips.consilioAnalyticsIndexSize',
  },
  {
    id: 'NativeFileSize',
    key: 'domainDashboard.gridColumns.nativeFileSize',
    tooltipKey: 'domainDashboard.columnTooltips.nativeFileSize',
  },
  {
    id: 'PublishedNativeFileSize',
    key: 'domainDashboard.gridColumns.publishedNativeFileSize',
    tooltipKey: 'domainDashboard.columnTooltips.publishedNativeFileSize',
  },
  {
    id: 'ReviewPopNativeFileSize',
    key: 'domainDashboard.gridColumns.reviewPopNativeFileSize',
    tooltipKey: 'domainDashboard.columnTooltips.reviewPopNativeFileSize',
  },
  {
    id: 'HostedTranslationFileSize',
    key: 'domainDashboard.gridColumns.hostedTranslationFileSize',
    tooltipKey: 'domainDashboard.columnTooltips.hostedTranslationFileSize',
  },
  {
    id: 'TextFileSize',
    key: 'domainDashboard.gridColumns.textFileSize',
    tooltipKey: 'domainDashboard.columnTooltips.textFileSize',
  },
  {
    id: 'HostedPDFFileSize',
    key: 'domainDashboard.gridColumns.hostedPDFFileSize',
    tooltipKey: 'domainDashboard.columnTooltips.hostedPDFFileSize',
  },
  {
    id: 'ReviewPopPDFFileSize',
    key: 'domainDashboard.gridColumns.reviewPopPDFFileSize',
    tooltipKey: 'domainDashboard.columnTooltips.reviewPopPDFFileSize',
  },
  {
    id: 'HostedNotReleasedPDFFileSize',
    key: 'domainDashboard.gridColumns.hostedNotReleasedPDFFileSize',
    tooltipKey: 'domainDashboard.columnTooltips.hostedNotReleasedPDFFileSize',
  },
  {
    id: 'ThirdPartyImageFileSize',
    key: 'domainDashboard.gridColumns.thirdPartyImageFileSize',
    tooltipKey: 'domainDashboard.columnTooltips.thirdPartyImageFileSize',
  },
  {
    id: 'ThirdPartyPDFFileSize',
    key: 'domainDashboard.gridColumns.thirdPartyPDFFileSize',
    tooltipKey: 'domainDashboard.columnTooltips.thirdPartyPDFFileSize',
  },
  {
    id: 'ThirdPartyNativeFileSize',
    key: 'domainDashboard.gridColumns.thirdPartyNativeFileSize',
    tooltipKey: 'domainDashboard.columnTooltips.thirdPartyNativeFileSize',
  },
  {
    id: 'ProductionImageFileSize',
    key: 'domainDashboard.gridColumns.productionImageFileSize',
    tooltipKey: 'domainDashboard.columnTooltips.productionImageFileSize',
  },
  {
    id: 'HostedAudioNativeFileSize',
    key: 'domainDashboard.gridColumns.hostedAudioNativeFileSize',
    tooltipKey: 'domainDashboard.columnTooltips.hostedAudioNativeFileSize',
  },
  {
    id: 'HostedMP3FileSize',
    key: 'domainDashboard.gridColumns.hostedMP3FileSize',
    tooltipKey: 'domainDashboard.columnTooltips.hostedMP3FileSize',
  },
  {
    id: 'ProcessedAudioTotalDuration',
    key: 'domainDashboard.gridColumns.processedAudioTotalDuration',
    tooltipKey: 'domainDashboard.columnTooltips.processedAudioTotalDuration',
  },
  {
    id: 'ProcessedAudioTrimmedDuration',
    key: 'domainDashboard.gridColumns.processedAudioTrimmedDuration',
    tooltipKey: 'domainDashboard.columnTooltips.processedAudioTrimmedDuration',
  },
  {
    id: 'AudioPhoneticIndexingDuration',
    key: 'domainDashboard.gridColumns.audioPhoneticIndexingDuration',
    tooltipKey: 'domainDashboard.columnTooltips.audioPhoneticIndexingDuration',
  },
];
